import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Http, Response } from '@angular/http';


import { BaseWebService } from "../../services/base-web.service";
import 'rxjs/add/observable/throw';
@Injectable()
export class PaymentDetailsPopupService {

    constructor(
        private _basewebservice: BaseWebService
    ) { }

    getPaymentDetails = (treatmentId: any) => {
        let query = "v1/patient_payment_detail/" + treatmentId + "/?logged_user=true";

        return this._basewebservice.request(query, "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    receivedOfflineDownPayment = (id: any, data: any) => {
        let reqData: any = {};
        reqData.body = data;
        let query = "v1/receive_dp/" + id + "/";
        return this._basewebservice.request(query, "put", reqData)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    receivedOffline = (id: any, data: any) => {
        let reqData: any = {};
        reqData.body = {
            status: 'completed',
            payment_method: "offline",
            payment_date: data.payment_date,
            send_confirmation_mail: data.send_confirmation_mail,
        };
        let query = "v1/patient_monthly_payment/" + id + "/";
        return this._basewebservice.request(query, "put", reqData)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    stopRecurring = (id: any) => {
        let reqData: any = {};
        reqData.body = {};
        let query = "v1/recurring_payment/" + id + "/";
        return this._basewebservice.request(query, "put", reqData)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    retryPayment = (id: any) => {
        let query = "v1/patient_monthly_payment/" + id + "/retry/";
        return this._basewebservice.request(query, "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    resendPortal = (id: any) => {
        const query = "v1/patient_payment_detail/" + id + "/send_portal_link/";
        return this._basewebservice.request(query, "post")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    getOneTimeRecalculations = (id: any, amount?: any, pay_type?: any) => {
        let query = "v1/one_time_payment/" + id + "/";
        if (amount && pay_type) {
            query = query + "?amount=" + amount + "&pay_type=" + pay_type;
        }

        return this._basewebservice.request(query, "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    oneTimeReceivedOffline = (id: any, oneTimeData: any) => {
        let query = "v1/one_time_payment/" + id + "/";
        const data: any = {};
        data.body = oneTimeData;
        return this._basewebservice.request(query, "post", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    receiptDownload(id: any) {
        return this._basewebservice.requestBlob("v1/billing/patient_statement/" + id + "/download/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    sendPaymentReminder = (id: any) => {
        const reqData: any = {};
        reqData.body = {};
        let query = "v1/send_payment_notification/" + id + "/";
        return this._basewebservice.request(query, "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    getPortalLink = (id: any) => {
        return this._basewebservice.request("v1/patient_payment_detail/" + id + "/portal_link/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
     * Function for handling service call errors
     * @param  {Response|any} error contains error data
     */

    handleError(error: Response | any) {
        return Observable.throw(error);
    }
}